import { CompaniesWithoutKeyContactsResultConstants } from "../constants/CompaniesWithoutKeyContactsResultConstants";
import { CompaniesWithoutKeyContactsResultServices } from "../services/CompaniesWithoutKeyContactsResultServices";
 
export const CompaniesWithoutKeyContactsResultActions = {
  fetchGetList,
};

function fetchGetList() {
  return (dispatch) => {
    dispatch(request());
    CompaniesWithoutKeyContactsResultServices.getList().then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: CompaniesWithoutKeyContactsResultConstants.FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_PENDING,
    };
  }

  function success(data) {
    return {
      type: CompaniesWithoutKeyContactsResultConstants.FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_GET_LIST_SUCCESS,
      payload: data,
    };
  }

  function failure(error) {
    return {
      type: CompaniesWithoutKeyContactsResultConstants.FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_RESULT_ERROR,
      error: error,
    };
  }
}
